import { toast } from 'react-toastify';
import { Schemas } from '../models/entities';

import * as ActionTypes from './types';

const fetchTerminals = (pageSize, pageNumber, sortBy, sortDesc, query) => ({
  [ActionTypes.API_CALL]: {
    method: 'GET',
    types: [
      ActionTypes.FETCH_TERMINALS_REQUEST,
      ActionTypes.FETCH_TERMINALS_SUCCESS,
      ActionTypes.FETCH_TERMINALS_FAILURE,
    ],
    schema: Schemas.TERMINAL_ARRAY,
    endpoint: `/api/terminals?page=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy || ''}&sortDesc=${sortDesc}&search=${query ? encodeURI(query) : ''}`,
  },
});

export const loadTerminals = (query) => (dispatch, getState) => {
  const {
    pageSize = 10,
    pageNumber = 0,
  } = getState().pagination.terminals || {};
  const {
    sortBy = 'id',
    sortDesc = false,
  } = getState().sorting.terminals || {};
  return dispatch(fetchTerminals(pageSize, pageNumber, sortBy, sortDesc, query))
    .catch((error) => toast.error(error.message));
};

const postTerminal = (body) => ({
  [ActionTypes.API_CALL]: {
    method: 'POST',
    types: [
      ActionTypes.ADD_TERMINAL_REQUEST,
      ActionTypes.ADD_TERMINAL_SUCCESS,
      ActionTypes.ADD_TERMINAL_FAILURE,
    ],
    endpoint: '/api/terminals',
    body,
  },
});

export const addTerminal = (terminal) => (dispatch) => dispatch(postTerminal(terminal));

const putTerminal = (terminal) => ({
  [ActionTypes.API_CALL]: {
    method: 'PUT',
    types: [
      ActionTypes.UPDATE_TERMINAL_REQUEST,
      ActionTypes.UPDATE_TERMINAL_SUCCESS,
      ActionTypes.UPDATE_TERMINAL_FAILURE,
    ],
    endpoint: `/api/terminals/${terminal.id}`,
    body: terminal,
  },
});

export const updateTerminal = (terminal) => (dispatch) => dispatch(putTerminal(terminal));

const patchDecommissionTerminal = (id) => ({
  [ActionTypes.API_CALL]: {
    method: 'PATCH',
    types: [
      ActionTypes.DECOMMISSION_TERMINAL_REQUEST,
      ActionTypes.DECOMMISSION_TERMINAL_SUCCESS,
      ActionTypes.DECOMMISSION_TERMINAL_FAILURE,
    ],
    endpoint: `/api/terminals/${id}/decommission`,
  },
});

const patchDeactivateTerminal = (id) => ({
  [ActionTypes.API_CALL]: {
    method: 'PATCH',
    types: [
      ActionTypes.DEACTIVATE_TERMINAL_REQUEST,
      ActionTypes.DEACTIVATE_TERMINAL_SUCCESS,
      ActionTypes.DEACTIVATE_TERMINAL_FAILURE,
    ],
    endpoint: `/api/terminals/${id}/deactivate`,
  },
});

const patchActivateTerminal = (id) => ({
  [ActionTypes.API_CALL]: {
    method: 'PATCH',
    types: [
      ActionTypes.ACTIVATE_TERMINAL_REQUEST,
      ActionTypes.ACTIVATE_TERMINAL_SUCCESS,
      ActionTypes.ACTIVATE_TERMINAL_FAILURE,
    ],
    endpoint: `/api/terminals/${id}/activate`,
  },
});

export const decommissionTerminal = (id) => (dispatch) => dispatch(patchDecommissionTerminal(id))
  .catch((error) => toast.error(error.message));

export const activateTerminal = (id) => (dispatch) => dispatch(patchActivateTerminal(id))
  .catch((error) => toast.error(error.message));

export const deactivateTerminal = (id) => (dispatch) => dispatch(patchDeactivateTerminal(id))
  .catch((error) => toast.error(error.message));
